import React, { memo } from 'react';
import { reportProps } from './StopLossAggregateTable';
import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  BasicTable,
  Columns,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';

import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import {
  convertDateRange,
  numberToCurrencyFormatter,
} from '../core-utils/helper-utils/helper';
import { cellStyles4 } from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/BasicTable';

export interface StopLossAggregateTopCardsProps {
  stopLossSummaryData: any;
  spentExpected: any;
  currentReserve: any;
}
type CombinedProps = reportProps & StopLossAggregateTopCardsProps;

const StopLossAggregateTopCards: React.FC<CombinedProps> = memo(
   
  ({ stopLossSummaryData, spentExpected, currentReserve }) => {
    const useStyles = makeStyles()({
      tableContainer: {
        width: '100%',
        display: 'flex',
      },
      titleContainer: {
        width: '320px',
        background: patientAccessTheme.palette.grey[700],
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    });
    const { classes } = useStyles();

    const stopLossSummary = [
      [
        stopLossSummaryData?.stop_loss_carrier ?? '-',
        convertDateRange(stopLossSummaryData?.specific_stop_loss?.[1]?.value),
        convertDateRange(stopLossSummaryData?.specific_stop_loss?.[2]?.value),
        stopLossSummaryData?.specific_deductible
          ? numberToCurrencyFormatter(
              stopLossSummaryData?.specific_deductible,
              true,
              0,
            )
          : '-',
        currentReserve ?? '-',
        spentExpected ? `${spentExpected}%` : '-',
      ],
    ];
    const stopLossSummaryColumns: Columns[] = [
      {
        name: 'Underwriter',
        align: 'center',
        cellStyles: cellStyles4,
        width: '250px',
      },
      {
        name: 'Incurred From',
        align: 'center',
        cellStyles: cellStyles4,
        width: '250px',
      },
      {
        name: 'Paid From',
        align: 'center',
        cellStyles: cellStyles4,
        width: '250px',
      },
      {
        name: 'Specific Deductible',
        align: 'center',
        cellStyles: cellStyles4,
        width: '250px',
      },
      {
        name: 'Current Reserve',
        align: 'center',
        cellStyles: cellStyles4,
        width: '250px',
      },
      {
        name: 'Spend vs Expected',
        align: 'center',
        cellStyles: cellStyles4,
        width: '250px',
      },
    ];
    return (
      <Grid className={classes.tableContainer}>
        <Grid className={classes.titleContainer}>
          <Typography
            fontSize="16px"
            fontType="semiBold"
            lineHeight="25.6px"
            textColor={patientAccessTheme.palette.status.white}
          >
            STOP LOSS SUMMARY
          </Typography>
        </Grid>
        <BasicTable
          columns={stopLossSummaryColumns}
          rowsData={stopLossSummary}
          displayType="box"
          isFullTable={true}
          cellHeight="36px"
        />
      </Grid>
    );
  },
);

export default StopLossAggregateTopCards;
